
    <ng-content></ng-content>
    <div *ngFor="let dir of directions"
      class="ngr-grabber" [ngClass]="'ngr-' + dir"
      (mousedown)="onMouseDown($event, dir)"
      (touchstart)="onMouseDown($event, dir)">
    </div>
  